import React from 'react';
import {
  View,
  Text,
  TouchableWithoutFeedback,
  StyleSheet,
  Image,
  Linking,
  TouchableOpacity,
} from 'react-native';
import Config from 'react-native-config';
import { useNavigation } from '@react-navigation/native';
import { useDispatch, useSelector } from 'react-redux';
import Utility from '../../utils/Utility';
import colors from '../../theme/Colors';
import size from '../../theme/Fonts';
import images from '../../theme/Images';
import FastImageView from '../../components/FastImageView';
import { getStoreRef } from '../../store/StoreUtility';
import { isBlank, isPresent, isWeb } from '../../utils/BooleanUtility';
import { AnalyticsManager, EventType } from '../../analytics';
import NavigationService from '../../navigator/NavigationService';
import { saveSelfieData } from '../../actions/SkinSelfieAnalysisActions';
import { PERMISSION_STORE } from '../../config/Constants';
import { setPhoneNumberModalInfo } from '../../actions/LoginActions';

const UserProfileCard = (props) => {
  const authToken = useSelector((state) => state.UserAccountInfo.authToken);
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const name = useSelector((state) => state.UserAccountInfo.profile?.name);
  const email = useSelector((state) => state.UserAccountInfo.profile?.email);
  const mobileNumber = useSelector(
    (state) => state.UserAccountInfo?.mobileNumber,
  );
  const selfieImageUrl = useSelector(
    (state) => state.UserAccountInfo?.selfieAnalysis?.selfie_image,
  );
  const fallbackSelfieImageUrl = useSelector(
    (state) => state.UserAccountInfo?.saveSelfieImage?.selfie_url,
  );
  const { itemData: { body = '', arguments: ctaText } = {} } = props;
  const { login_cta = 'Edit Profile', logged_out_cta = 'Login' } = ctaText;
  const selfieImageToUse = isPresent(selfieImageUrl) ? selfieImageUrl : fallbackSelfieImageUrl;
  const imageToUse = selfieImageToUse || images.profilePicPlaceholder;
  const editProfile = () => {
    AnalyticsManager.logEvent(EventType.myProfile.PROFILE_COMPLETE_INITIATE);
    navigation.navigate('ProfileEdit');
  };
  const handleLoginAction = () => {
    dispatch(setPhoneNumberModalInfo(Utility.getLoginModalInfo('DEFAULT')));
    NavigationService.renderOnboarding();
  };

  const navigateToSelfie = () => {
    dispatch(saveSelfieData({ uploadedSelfieStatus: '' }));
    Utility.checkPermissionStatic(
      PERMISSION_STORE.camera,
      true,
      (permissionStatus) => {
        if (
          permissionStatus === 'granted' ||
          permissionStatus === 'authorized'
        ) {
          navigation.navigate('TakeSkinSelfie', {
            previousScreen: 'ForYou',
          });
        } else if (
          permissionStatus === 'never_ask_again' ||
          permissionStatus === 'denied'
        ) {
          Linking.openSettings();
        }
      },
    );
  };

  if (isBlank(authToken)) {
    return (
      <View style={styles.container}>
        <View style={styles.loggedOutContainer}>
          <View style={styles.textButtonContainer}>
            <Text style={styles.name}>{body || 'Welcome to Foxy'}</Text>
            <TouchableWithoutFeedback onPress={handleLoginAction}>
              <View style={styles.loggedOutButtonContainer}>
                <Text style={styles.buttonTitle}>{logged_out_cta}</Text>
                <Image
                  source={images.chevronRight}
                  style={styles.chevronRight}
                />
              </View>
            </TouchableWithoutFeedback>
          </View>
          <TouchableOpacity onPress={navigateToSelfie}>
            <FastImageView
              source={images.profilePicPlaceholder}
              style={styles.profileImage}
            />
          </TouchableOpacity>
        </View>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        <View>
          {name && <Text style={styles.name}>{name}</Text>}
          <Text style={styles.phone}>{mobileNumber}</Text>
          {email && <Text style={styles.email}>{email}</Text>}
          <TouchableWithoutFeedback onPress={editProfile}>
            <View style={styles.buttonContainer}>
              <Text style={styles.buttonTitle}>{login_cta}</Text>
              <Image source={images.chevronRight} style={styles.chevronRight} />
            </View>
          </TouchableWithoutFeedback>
        </View>
        <TouchableOpacity onPress={navigateToSelfie}>
          <FastImageView source={imageToUse} style={styles.profileImage} />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#F5F7F9',
    borderRadius: 12,
    margin: 16,
  },
  loggedOutContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  textButtonContainer: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  innerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  name: {
    fontSize: 18,
    fontWeight: 'bold',
    color: colors.black,
    fontFamily: 'Roboto-Regular',
  },
  phone: {
    fontSize: 16,
    color: '#64748B',
    marginTop: 4,
  },
  email: {
    fontSize: 16,
    color: '#64748B',
    marginTop: 2,
  },
  profileImage: {
    width: 56,
    height: 56,
    borderRadius: 30,
  },
  buttonContainer: {
    borderRadius: 8,
    backgroundColor: isPresent(Config.THEME_COLOR)
      ? Config.THEME_COLOR
      : colors.black,
    height: 30,
    flexDirection: 'row',
    paddingHorizontal: isWeb() ? 10 : 14,
    marginRight: 8,
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 90,
    maxWidth: 110,
    marginTop: 8,
  },
  loggedOutButtonContainer: {
    borderRadius: 8,
    backgroundColor: isPresent(Config.THEME_COLOR)
      ? Config.THEME_COLOR
      : colors.black,
    height: 30,
    flexDirection: 'row',
    paddingLeft: 14,
    paddingRight: 14,
    justifyContent: 'center',
    alignItems: 'center',
    width: 90,
    marginTop: 8,
  },
  buttonTitle: {
    fontFamily: 'Roboto',
    color: colors.white,
    fontSize: size.h4,
  },
  chevronRight: {
    height: 10,
    width: 10,
    marginLeft: 4,
  },
});

export default UserProfileCard;
